import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Expand } from "@sparefoot/react-commons";
import { Button } from "components/core/Button";
import { Link } from "components/core/Link";
import { Chevron } from "components/core/Icons";

import "./HeaderMenu.scss";

// Submenu parent items are dropdown labels (not navigable links). We still
// mirror the classes that `Link` would apply for `<Link last color="blue" />`
// so styling remains consistent. If `Link`'s class generation changes, update
// this string to match.
const SUBMENU_PARENT_LABEL_CLASSNAME =
	"sf-link link-menu-header last sf-type color-blue";

function HeaderMenu({
	menuName,
	links,
	className,
	openMenuName,
	setOpenMenuName,
	isStacked
}) {
	const [expanded, setExpanded] = useState(false);

	const handleExpand = () => {
		setExpanded(!expanded);
		setOpenMenuName(menuName);
	};

	useEffect(() => {
		if (menuName !== openMenuName) setExpanded(false);
	}, [openMenuName]);

	return (
		<div
			className={classnames(
				"header-menu",
				{ stacked: isStacked },
				className
			)}
		>
			<Button
				title={`${expanded ? "Close" : "Open"} ${menuName} menu`}
				onClick={handleExpand}
				className={classnames("button-menu", {
					"button-expanded": expanded,
					"button-collapsed": !expanded
				})}
				withIcon
			>
				{menuName}
				<Chevron rotate={expanded ? "up" : "down"} />
			</Button>
			<Expand expanded={expanded}>
				<div>
					{links.map(({ href, text, submenu }) => (
						<Fragment key={`fragment-${text}`}>
							{submenu ? (
								<span
									className={SUBMENU_PARENT_LABEL_CLASSNAME}
								>
									{text}
								</span>
							) : (
								<Link
									last
									className="link-menu"
									href={href}
								>
									{text}
								</Link>
							)}
							{submenu?.map((sub) => (
									<Link
										last
										color="lightBlue"
										className="link-submenu"
										href={sub.href}
										key={sub.text}
									>
										{sub.text}
									</Link>
								))}
						</Fragment>
					))}
				</div>
			</Expand>
		</div>
	);
}

HeaderMenu.propTypes = {
	isStacked: PropTypes.bool,
	menuName: PropTypes.string,
	links: PropTypes.arrayOf(PropTypes.object).isRequired,
	className: PropTypes.string,
	openMenuName: PropTypes.string,
	setOpenMenuName: PropTypes.func
};

export default HeaderMenu;
